<template>
	<div id="users" class="users">
		<template v-if="users && users.length > 0">
			<div v-for="(user,index) in users" :key="'user-'+index + '-' + user.userid"  @click="selectUser(user)">
				<user-item v-model="users[index]" :selected="selectedUser != null && users[index].userid == selectedUser.userid"></user-item>					
			</div>
		</template>
		<div v-else>
			<div class="text-center" style="margin-top: 10px">
				No users
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import userItem from './livechat-user-item'
import api from '@/api'

export default{
	props: ['value','type'],
	data: function(){
		return {
			loading : false,
			maxTime : 10000,
		    timer: '',

			selectedUser: this.value,
			windowHeight: 0,
			limit: 100,
			offset: 0,
			users : [],
		}
	},
	computed: {
	    ...mapGetters({
	        selectedBot: 'selectedBot'
	    }),
	},
	components: {
		'user-item' : userItem,
	},
	created: function(){
		this.timer = setInterval(this.getLiveChatUsers, this.maxTime)
	},
	mounted: function(){
		let vm = this
		vm.getLiveChatUsers()
		vm.windowHeight = window.innerHeight
		vm.matchChatboxHeight();

		vm.$nextTick(function() {
			window.addEventListener('resize', function(e) {
				vm.windowHeight = window.innerHeight
				vm.matchChatboxHeight();
			});
		})

	},
	methods: {
		selectUser: function(user){
			user.type = this.type
			this.selectedUser = user
			this.$emit('input',user)
		},
		getLiveChatUsers: function(){
			let vm = this
			if (vm.loading) {
				return false
			}
			vm.loading = true
			let data = {
				pageid : vm.selectedBot.pageid,
				offset: vm.offset,
				limit: vm.limit,
				type: vm.type
			}
			// vm.$store.dispatch('loading')
			api.getLiveChatUsers(data,function(error, response){
				if (error) {
					console.error(error)
					// vm.$store.dispatch('loading')
					return
				}
				if (response.data) {
					vm.users = response.data
					// if (vm.selectedUser == null && vm.users.length > 0) {
					// 	vm.selectUser(vm.users[0])
					// }
					vm.loading = false
				}
				// vm.$store.dispatch('loading')
			})
		},
		matchChatboxHeight: function() {
			let vm = this
			let totalHeight = vm.windowHeight
			let headerHeight = $('header').outerHeight(true)
			let typeHeight = $('#chattype').outerHeight(true)
			totalHeight = totalHeight - headerHeight - typeHeight
			$('.users').height(totalHeight)	

		}
	},
	watch: {
		type: function(newVal,oldVal) {
			let vm = this
			console.log(newVal)
			if (newVal != oldVal) {
				vm.users = []
				vm.getLiveChatUsers()
			}
		},
		selectedBot: function(newVal, oldVal){
			let vm = this
			if (newVal != oldVal) {
				vm.users = []
				vm.getLiveChatUsers()
			}
		},
		value: function(newVal,oldVal) {
			let vm = this
			if (newVal != oldVal) {
				vm.selectedUser = newVal
			}
		}
	},
	beforeDestroy: function() {
		clearInterval(this.timer)
	}
}
</script>


// WEBPACK FOOTER //
// src/components/view/livechat/livechat-users.vue